export const iconFontAwesomeHandsHandshakeSimpleSlash = (
	<i className="fa-solid fa-handshake-simple-slash"></i>
);
